import {SimplePage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";

import {useQuery} from "@tanstack/react-query";
import {useAuth} from "../../../contexts/AuthContext";
import ListViewTable, {TableLink} from "../../elements/tables/ListViewTable";
import SchoolYearFilter from "../../elements/SchoolYearFilter";
import {useSchoolYears} from "../../../contexts/SchoolYearContext";
import {
    getPlupusExcel,
    getPlupusV2CurrentExcel,
    getStudentList,
    getStudentListCurrentV2, getStudentListCurrentV2Excel,
    getStudentListV2
} from "../../../api/plupus";
import {DownloadButton} from "../../elements/Buttons";
import env from "react-dotenv";


const columns = [
    {
        accessorKey: "points_rank",
        id: "points_rank",
        header: "Ranking",
        enableColumnFilter: false,
    },
    {
        accessorFn: (row) =>
            `${row.last_name}, ${row.first_name} ${row.student_number}`,
        id: "student_search",
        header: "SchülerIn",
        hide: false,
        enableColumnFilter: false,
    },
    {
        accessorKey: "school_class",
        id: "school_class",
        header: "Klasse",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        sortingFn: "schoolClassSorting",
        filterFn: "containsString"
    },
    {
        accessorKey: "grade",
        id: "grade",
        header: "Stufe",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        filterFn: "containsString"
    },
    {
        accessorKey: "house",
        id: "house",
        header: "Mentorat",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        filterFn: "containsString"
    },
    {
        accessorKey: "points_actual",
        id: "points_actual",
        header: "Punkte",
        enableColumnFilter: false,
    },
    {
        accessorKey: "rating_actual",
        id: "rating_actual",
        header: "Stufe",
        enableColumnFilter: false
    },
    {
        accessorKey: "points_forecast",
        id: "points_forecast",
        header: "Punkte (Prognose)",
        enableColumnFilter: false,
    },
    {
        accessorKey: "rating_forecast",
        id: "rating_forecast",
        header: "Status (Prognose)",
        enableColumnFilter: false,
    }
];

export default function StudentsCurrentV2() {
    const {permissions} = useAuth();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["plupus_current_v2"],
        () => getStudentListCurrentV2()
    );

    function getRowLink(row) {
        return `/plupus/v2/students/${row.original.id}/`;
    }

    function getTrClassNames(row, index) {
        return row.original.rating_actual == "Grün" ? 'bg-green-50' : row.original.rating_actual == "Orange" ? 'bg-yellow-50' : 'bg-blue-50'
    }

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Aktuelle Plupus (Farbensystem) nach Schülern
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">

                        <DownloadButton
                            apiFunction={() => getStudentListCurrentV2Excel()}
                            fileName={`Plupus.xls`}
                            label="Liste herunterladen"/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getTrClassNames={getTrClassNames}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
